import { Frequency as FrequencyApi } from '@vendasta/billing';

export enum Frequency {
  Invalid = 'INVALID',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY',
  OneTime = 'ONE_TIME',
}

export function frequencyFromLegacyApi(fApi: string): Frequency {
  switch (fApi) {
    case 'monthly':
      return Frequency.Monthly;
    case 'yearly':
      return Frequency.Yearly;
    case 'one_time':
      return Frequency.OneTime;
  }
  return Frequency.Invalid;
}

export function frequencyFromApi(fApi: FrequencyApi | undefined): Frequency {
  switch (fApi) {
    case FrequencyApi.MONTHLY:
      return Frequency.Monthly;
    case FrequencyApi.YEARLY:
      return Frequency.Yearly;
    case FrequencyApi.ONE_TIME:
      return Frequency.OneTime;
  }
  return Frequency.Invalid;
}

export function frequencyToApi(frequency: Frequency | undefined): FrequencyApi {
  switch (frequency) {
    case Frequency.Monthly:
      return FrequencyApi.MONTHLY;
    case Frequency.Yearly:
      return FrequencyApi.YEARLY;
    case Frequency.OneTime:
      return FrequencyApi.ONE_TIME;
  }
  return FrequencyApi.INVALID;
}
